"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _InputBase = _interopRequireDefault(require("@mui/material/InputBase"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// Material UI

var TextField = (0, _styles.styled)(_InputBase["default"])(function (_ref) {
  var theme = _ref.theme;
  return {
    "label + &": {
      marginTop: theme.spacing(3)
    },
    "& .MuiInputBase-input": {
      borderRadius: 4,
      position: "relative",
      backgroundColor: "rgba(255,255,255,.1)",
      color: theme.palette.common.white,
      fontSize: 16,
      // marginBottom: 20,
      padding: "10px 12px",
      transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: ["-apple-system", "BlinkMacSystemFont", '"Segoe UI"', "Roboto", '"Helvetica Neue"', "Arial", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(","),
      "&:focus": {
        boxShadow: "".concat((0, _styles.alpha)(theme.palette.primary.main, 0.25), " 0 0 0 0.2rem"),
        borderColor: theme.palette.primary.main
      }
    }
  };
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(TextField);